import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Img from 'gatsby-image'
import animateScrollTo from 'animated-scroll-to'

import Collapsible from '../components/collapsible'
import plusBlack from '../images/svg/plus-black.svg'
import plusOrange from '../images/svg/plus-orange.svg'
import './pubblicazioni.sass'

export default class PubblicazioniPage extends Component {
  state = {
    // Nell'accordion, il pannello aperto (solo uno alla volta può stare aperto)
    openPanel: null,
  }

  // Apre il pannello cliccato e poi scrolla la pagina in modo da includerlo
  // tutto nel viewport
  handleCollapsibleClick = openPanel => {
    if (this.state.openPanel === openPanel) {
      return this.setState({ openPanel: null })
    }

    this.setState({ openPanel })

    const openElement = document.querySelector(`#${openPanel}`)
    setTimeout(() => animateScrollTo(openElement, { offset: -70 }), 500)
  }

  render() {
    const { data } = this.props
    const libri = data.allDatoCmsPubblicazione.edges
      .map(edge => edge.node)
      .filter(libro => {
        return libro.titolo.indexOf('esempio') < 0
      })

    return (
      <div>
        <Helmet>
          <title>Pubblicazioni | {data.site.siteMetadata.title}</title>
        </Helmet>

        <div className="Pubblicazioni wrap-narrower">
          {/* libri */}

          <h1 className="text-primary">Pubblicazioni</h1>

          <div className="Pubblicazioni__List">
            {libri.map((libro, index) => (
              <Collapsible
                key={index}
                id={`libro-${index}`}
                isOpened={this.state.openPanel === `libro-${index}`}
                onClick={this.handleCollapsibleClick}
                title={() => <div>{libro.titolo}</div>}
                collapsedIcon={plusBlack}
                expandedIcon={plusOrange}
                expandedColor="#a6bdc3"
                titlePaddingLeft="0px"
              >
                <div className="Pubblicazioni__ListItem__Detail">
                  <div
                    className="Pubblicazioni__ListItem__Text"
                    dangerouslySetInnerHTML={{ __html: libro.descrizione }}
                  />

                  <div className="Pubblicazioni__ListItem__Image">
                    <Img
                      sizes={libro.immagine.sizes}
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </div>
                </div>
              </Collapsible>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query Pubblicazioni {
    site {
      siteMetadata {
        title
      }
    }
    allDatoCmsPubblicazione {
      edges {
        node {
          titolo
          descrizione
          immagine {
            size
            sizes {
              sizes
              srcSet
              src
              base64
              aspectRatio
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/pubblicazioni.js